import { useState, useEffect } from 'react';

export const useGetScrollOffsetFromParent = () => {
  const [scrollOffset, setScrollOffset] = useState(0);

  useEffect(() => {
    const handleRecieveMessage = (event: MessageEvent) => {
      const { pageYOffset } = event.data;
      if (!pageYOffset) return;

      setScrollOffset(pageYOffset);
    };
    window.addEventListener('message', handleRecieveMessage);

    return () => window.removeEventListener('message', handleRecieveMessage);
  }, []);

  return scrollOffset
};
